<script setup lang="ts">
import type { TickerItem } from '~/composables/useSocialApi'

const PAGE_SIZE = 10
const ROTATE_INTERVAL = 8000

const props = defineProps<{
  items: TickerItem[]
}>()

const pageIndex = ref(0)

const totalPages = computed(() =>
  Math.max(1, Math.ceil(props.items.length / PAGE_SIZE)),
)

const visibleItems = computed(() => {
  const start = pageIndex.value * PAGE_SIZE
  return props.items.slice(start, start + PAGE_SIZE)
})

let timer: ReturnType<typeof setInterval> | null = null

onMounted(() => {
  timer = setInterval(() => {
    if (totalPages.value <= 1) return
    pageIndex.value = (pageIndex.value + 1) % totalPages.value
  }, ROTATE_INTERVAL)
})

onUnmounted(() => {
  if (timer) clearInterval(timer)
})
</script>

<template>
  <div
    v-if="items.length > 0"
    class="activity-ticker"
  >
    <div class="ticker-title">
      魔法研究会通信
    </div>
    <transition
      name="ticker-fade"
      mode="out-in"
    >
      <div
        :key="pageIndex"
        class="ticker-content"
      >
        <div
          v-for="(item, index) in visibleItems"
          :key="index"
          class="ticker-item"
        >
          <span class="ticker-text">{{ item.text }}</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<style scoped>
.activity-ticker {
  position: absolute;
  left: 1.5%;
  bottom: 2%;
  z-index: 2;

  width: 32%;
  overflow: hidden;

  background-color: rgba(20, 10, 5, 0.7);
  border: 1px solid rgba(245, 229, 170, 0.3);
  border-radius: max(4px, calc(0.5 * var(--u)));
  padding: max(6px, calc(0.8 * var(--u)));
}

.ticker-title {
  color: rgba(245, 229, 170, 1);
  font-size: max(8px, calc(1.05 * var(--u)));
  font-weight: bold;
  text-align: center;
  padding-bottom: max(3px, calc(0.3 * var(--u)));
  border-bottom: 1px solid rgba(245, 229, 170, 0.3);
  margin-bottom: max(3px, calc(0.3 * var(--u)));
}

.ticker-content {
  display: flex;
  flex-direction: column;
}

.ticker-item {
  padding: max(3px, calc(0.4 * var(--u))) max(4px, calc(0.5 * var(--u)));
  border-bottom: 1px solid rgba(245, 229, 170, 0.1);
}

.ticker-item:last-child {
  border-bottom: none;
}

.ticker-text {
  color: rgba(245, 229, 170, 0.9);
  font-size: max(9px, calc(1.1 * var(--u)));
  line-height: 1.4;
}

.ticker-fade-enter-active,
.ticker-fade-leave-active {
  transition: opacity 0.5s ease;
}

.ticker-fade-enter-from,
.ticker-fade-leave-to {
  opacity: 0;
}
</style>
